<div *ngIf="show && employee" class="popup-backdrop" (click)="onBackdropClick()">
  <div class="popup-panel" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="popup-header">
      <div class="popup-header-info">
        <span class="popup-title">Employee Details</span>
        <span class="popup-subtitle">{{ employee.employeeName }}</span>
      </div>
      <button class="close-btn" (click)="onClose()" title="Close">
        <emerald-icon icon="close" [fontSize]="1.25"></emerald-icon>
      </button>
    </div>

    <div class="popup-divider"></div>

    <!-- Body -->
    <div class="popup-body">

      <!-- General Info Card -->
      <div class="detail-card">
        <div class="card-section-title">
          <emerald-icon icon="person" [fontSize]="1"></emerald-icon>
          <span>General Information</span>
        </div>
        <div class="detail-grid">

          <!-- All general rows except Last Working Day -->
          <div class="detail-row" *ngFor="let row of generalDetails">
            <span class="detail-label">{{ row.label }}</span>
            <span class="detail-value" [title]="row.value?.toString()">{{ row.value ?? '—' }}</span>
          </div>

          <div class="detail-row">
            <span class="detail-label">Location</span>
            <div class="value-group-editor">
              <select
                *ngIf="isLocationDropdownOpen"
                class="location-select"
                (change)="onLocationSelected($event)"
              >
                <option *ngFor="let loc of locations" [value]="loc" [selected]="loc === employee.location">
                  {{ loc }}
                </option>
              </select>

              <span class="detail-value" *ngIf="!isLocationDropdownOpen">{{ employee.location || '—' }}</span>

              <button
                *ngIf="!isLocationDropdownOpen"
                class="edit-icon-btn"
                title="Edit Location"
                (click)="toggleLocationDropdown($event)"
              >
                <emerald-icon icon="edit" [fontSize]="1"></emerald-icon>
              </button>
              <button
                *ngIf="isLocationDropdownOpen"
                class="close-icon-btn"
                title="Cancel"
                (click)="toggleLocationDropdown($event)"
              >
                <emerald-icon icon="close" [fontSize]="1"></emerald-icon>
              </button>
            </div>
          </div>

          <!-- Last Working Day always last, always has edit icon -->
          <div class="detail-row last-working-day-row">
            <span class="detail-label">Last Working Day</span>
            <div class="value-group-editor">
              <span class="detail-value" *ngIf="lastWorkingDay">{{ lastWorkingDay }}</span>
              <span class="detail-value" *ngIf="!lastWorkingDay">—</span>
              <button
                class="edit-icon-btn"
                [title]="lastWorkingDay ? 'Edit Last Working Day' : 'Set Last Working Day'"
                (click)="toggleCalendar()"
              >
                <emerald-icon icon="edit" [fontSize]="1"></emerald-icon>
              </button>
              <button
                *ngIf="lastWorkingDay"
                class="delete-icon-btn"
                title="Delete Last Working Day"
                (click)="deleteLastWorkingDay()"
              >
                <emerald-icon icon="delete" [fontSize]="1"></emerald-icon>
              </button>
            </div>
          </div>

        </div>
      </div>

      <!-- Timesheet Summary Card -->
      <div class="detail-card">
        <div class="card-section-title">
          <emerald-icon icon="schedule" [fontSize]="1"></emerald-icon>
          <span>Timesheet Summary</span>
        </div>
        <div class="detail-grid">
          <div class="detail-row" *ngFor="let row of timesheetDetails">
            <span class="detail-label">{{ row.label }}</span>
            <span class="detail-value">{{ row.value ?? '—' }}</span>
          </div>
        </div>
      </div>

    </div><!-- /popup-body -->

    <div class="popup-divider"></div>

    <!-- Footer -->
    <div class="popup-footer">
      <emerald-button label="Close" type="Secondary" (onClick)="onClose()"></emerald-button>
    </div>

  </div>
</div>

<!-- Calendar overlay — outside popup-panel so it is never clipped -->
<div class="calendar-overlay" *ngIf="show && isCalendarOpen" (click)="isCalendarOpen = false">
  <div class="calendar-panel" (click)="$event.stopPropagation()">

    <div class="calendar-loading" *ngIf="isLoadingLeaves">Loading leave data…</div>

    <div class="calendar-body">

      <!-- Left: mat-calendar + legend -->
      <div class="calendar-left">
        <mat-calendar
          #calendar
          [selected]="selectedDate"
          [startAt]="selectedDate"
          [maxDate]="maxDate"
          [dateClass]="dateClass"
          (selectedChange)="onDateSelected($event)"
        ></mat-calendar>

        <!-- Legend -->
        <div class="calendar-legend">
          <div class="legend-item">
            <span class="legend-dot public-holiday"></span><span>Public Holiday</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot unpaid"></span><span>Unpaid Leave</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot halfunpaid"></span><span>Half Unpaid Leave</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot paid"></span><span>Paid Leave</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot halfpaid"></span><span>Half Paid Leave</span>
          </div>
        </div>
      </div>

      <!-- Right: leave summary column -->
      <div class="calendar-summary" *ngIf="!isLoadingLeaves && summary.length > 0">
        <div class="summary-item" *ngFor="let item of getFilteredSummary()">
          <div class="summary-label">{{ item.text }}</div>
          <div class="summary-value">{{ item.value }}</div>
        </div>
      </div>

    </div>
  </div>
</div>